import { label, primary } from 'styles'

import { makeStyles } from '@mui/styles'
import type { Theme } from '@mui/system'

export default makeStyles((theme: Theme) => ({
  appBar: {
    '&&': {
      background: primary,
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem !important', // MUI is adding inline style which cannot be overwritten
      position: 'relative',
    },
  },
  fieldDetails: {
    '&&': {
      marginTop: '1.5rem',
    },
  },
  imageWrapper: {
    background: `linear-gradient(transparent 50%, ${label} 50%)`,
    paddingBottom: '3rem',
  },
  inputLabel: {
    '&&': {
      [theme.breakpoints.down('lg')]: {
        '&.Mui-focused': {
          transform: 'translate(0, 0.3rem) scale(0.75)',
        },
        '&.MuiInputLabel-shrink': {
          transform: 'translate(0, 0.3rem) scale(0.75)',
        },
      },
      [theme.breakpoints.down('sm')]: {
        '&.Mui-focused': {
          transform: 'translate(0, 0.6rem) scale(0.75)',
        },
        '&.MuiInputLabel-shrink': {
          transform: 'translate(0, 0.6rem) scale(0.75)',
        },
      },
    },
  },
  screenshot: {
    borderRadius: '1rem',
    height: '100%',
    objectFit: 'contain',
    width: '100%',
  },
  title: {
    '&&': {
      fontWeight: '600',
      marginLeft: '1rem',
    },
    textTransform: 'uppercase',
  },
  toolbar: {
    '&&': {
      paddingLeft: '0',
      paddingRight: '0',
    },
  },
}))
